import { render, staticRenderFns } from "./ClientDetail.vue?vue&type=template&id=ab077194&"
import script from "./ClientDetail.vue?vue&type=script&lang=js&"
export * from "./ClientDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClientDetail.vue?vue&type=style&index=0&id=ab077194&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab077194')) {
      api.createRecord('ab077194', component.options)
    } else {
      api.reload('ab077194', component.options)
    }
    module.hot.accept("./ClientDetail.vue?vue&type=template&id=ab077194&", function () {
      api.rerender('ab077194', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDetail.vue"
export default component.exports